var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ProximitySensor50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B2EBF2",
    d: "M32 15A9 9 0 1 0 32 33A9 9 0 1 0 32 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DD0E1",
    d: "M32,12c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S38.6,12,32,12z M32,32c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S36.4,32,32,32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F51B5",
    d: "M25.4 22L19.8 5.1 13.6 27.7 11.4 22 4 22 4 26 8.6 26 14.4 40.3 20.2 18.9 22.6 26 30 26 30 22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F51B5",
    d: "M32 20A4 4 0 1 0 32 28A4 4 0 1 0 32 20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ProximitySensor50);
export default __webpack_public_path__ + "static/media/icons8-proximity-sensor-50.c788ceef38be89593b1c21269b502582.svg";
export { ForwardRef as ReactComponent };